import { useMemo } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

type EnumOption = {
  label: string;
  value: string;
};

export const SearchableEnumPickerField = (
  props: FieldExtensionComponentProps<string>,
) => {
  const { schema, onChange, formData, required, rawErrors } = props;

  const enumValues = ((schema.enum as string[] | undefined) ?? []).map(String);
  const enumNames = ((schema as { enumNames?: string[] }).enumNames ?? []).map(String);

  const options = useMemo<EnumOption[]>(() => {
    return enumValues.map((value, idx) => ({
      value,
      label: enumNames[idx] ?? value,
    }));
  }, [enumNames, enumValues]);

  const selected = useMemo(
    () => options.find(o => o.value === (formData ?? '')) ?? null,
    [formData, options],
  );

  return (
    <Autocomplete
      options={options}
      value={selected}
      onChange={(_, option) => onChange(option?.value ?? '')}
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={params => (
        <TextField
          {...params}
          label={schema.title}
          required={required}
          error={Boolean(rawErrors?.length)}
          helperText={rawErrors?.[0] ?? (schema.description as string | undefined)}
          size="small"
          fullWidth
        />
      )}
    />
  );
};
